import React, { ReactNode, createContext, useContext, useState } from "react";

import { Form } from "../../../model/form/Form";
import { FormsFolder } from "../../../model/form/types/FormsFolder";

interface AtiraFormContextType {
  formCreateEditDrawerVisible: boolean;
  setFormCreateEditDrawerVisible: ATVoidFunction<boolean>;
  selectedForm: Form | null;
  setSelectedForm: ATVoidFunction<Form | null>;
  highlightedFormId: string | null;
  setHighlightedFormId: ATVoidFunction<string | null>;
  //
  formAssignVisible: boolean;
  setFormAssignVisible: ATVoidFunction<boolean>;
  formReadVisible: boolean;
  setFormReadVisible: ATVoidFunction<boolean>;
  formShareVisible: boolean;
  setFormShareVisible: ATVoidFunction<boolean>;
  formDeleteVisible: boolean;
  setFormDeleteVisible: ATVoidFunction<boolean>;
  formDuplicateVisible: boolean;
  setFormDuplicateVisible: ATVoidFunction<boolean>;
  formUpdateStatusVisible: boolean;
  setFormUpdateStatusVisible: ATVoidFunction<boolean>;
  formReCaptchaConfigureVisible: boolean;
  setFormReCaptchaConfigureVisible: ATVoidFunction<boolean>;
  formAutoAssignVisible: boolean;
  setFormAutoAssignVisible: ATVoidFunction<boolean>;
  formActivityVisible: boolean;
  setFormActivityVisible: ATVoidFunction<boolean>;
  formCalendarVisible: boolean;
  setFormCalendarVisible: ATVoidFunction<boolean>;
  //
  selectedFolder: FormsFolder | null;
  setSelectedFolder: ATVoidFunction<FormsFolder | null>;
  formsFolderCreateVisible: boolean;
  setFormsFolderCreateVisible: ATVoidFunction<boolean>;
  formsFolderUpdateVisible: boolean;
  setFormsFolderUpdateVisible: ATVoidFunction<boolean>;
  formsFolderDeleteVisible: boolean;
  setFormsFolderDeleteVisible: ATVoidFunction<boolean>;
  formAddToFolderVisible: boolean;
  setFormAddToFolderVisible: ATVoidFunction<boolean>;
  formRemoveFromFolderVisible: boolean;
  setFormRemoveFromFolderVisible: ATVoidFunction<boolean>;
}

const AtiraFormContext = createContext<AtiraFormContextType | undefined>(
  undefined,
);

export const useAtiraFormContext = () => {
  const context = useContext(AtiraFormContext);

  if (!context) {
    throw new Error(
      "useAtiraFormContext must be used within a AtiraFormContextProvider",
    );
  }

  return context;
};

interface AtiraFormContextProviderProps {
  children: ReactNode;
}

export const AtiraFormContextProvider: React.FC<
  AtiraFormContextProviderProps
> = ({ children }) => {
  const [formCreateEditDrawerVisible, setFormCreateEditDrawerVisible] =
    useState(false);
  const [selectedForm, setSelectedForm] = useState<Form | null>(null);
  const [highlightedFormId, setHighlightedFormId] = useState<string | null>(
    null,
  );
  //
  const [formShareVisible, setFormShareVisible] = useState(false);
  const [formReadVisible, setFormReadVisible] = useState(false);
  const [formDeleteVisible, setFormDeleteVisible] = useState(false);
  const [formDuplicateVisible, setFormDuplicateVisible] = useState(false);
  const [formUpdateStatusVisible, setFormUpdateStatusVisible] = useState(false);
  const [formAssignVisible, setFormAssignVisible] = useState(false);
  const [formReCaptchaConfigureVisible, setFormReCaptchaConfigureVisible] =
    useState(false);
  const [formAutoAssignVisible, setFormAutoAssignVisible] = useState(false);
  const [formActivityVisible, setFormActivityVisible] = useState(false);
  const [formCalendarVisible, setFormCalendarVisible] = useState(false);
  //
  const [selectedFolder, setSelectedFolder] = useState<FormsFolder | null>(
    null,
  );
  const [formsFolderCreateVisible, setFormsFolderCreateVisible] =
    useState(false);
  const [formsFolderUpdateVisible, setFormsFolderUpdateVisible] =
    useState(false);
  const [formsFolderDeleteVisible, setFormsFolderDeleteVisible] =
    useState(false);
  const [formAddToFolderVisible, setFormAddToFolderVisible] = useState(false);
  const [formRemoveFromFolderVisible, setFormRemoveFromFolderVisible] =
    useState(false);

  return (
    <AtiraFormContext.Provider
      value={{
        setFormCreateEditDrawerVisible,
        formCreateEditDrawerVisible,
        selectedForm,
        setSelectedForm,
        highlightedFormId,
        setHighlightedFormId,
        formShareVisible,
        setFormShareVisible,
        formReadVisible,
        setFormReadVisible,
        formDeleteVisible,
        setFormDeleteVisible,
        formDuplicateVisible,
        setFormDuplicateVisible,
        formUpdateStatusVisible,
        setFormUpdateStatusVisible,
        formAssignVisible,
        setFormAssignVisible,
        formReCaptchaConfigureVisible,
        setFormReCaptchaConfigureVisible,
        formAutoAssignVisible,
        setFormAutoAssignVisible,
        //
        selectedFolder,
        setSelectedFolder,
        formsFolderCreateVisible,
        setFormsFolderCreateVisible,
        formsFolderUpdateVisible,
        setFormsFolderUpdateVisible,
        formsFolderDeleteVisible,
        setFormsFolderDeleteVisible,
        formAddToFolderVisible,
        setFormAddToFolderVisible,
        formRemoveFromFolderVisible,
        setFormRemoveFromFolderVisible,
        formActivityVisible,
        setFormActivityVisible,
        formCalendarVisible,
        setFormCalendarVisible,
      }}
    >
      {children}
    </AtiraFormContext.Provider>
  );
};
